import { render, staticRenderFns } from "./CateringCard.vue?vue&type=template&id=6e3c7528&scoped=true"
import script from "./CateringCard.vue?vue&type=script&lang=js"
export * from "./CateringCard.vue?vue&type=script&lang=js"
import style0 from "./CateringCard.vue?vue&type=style&index=0&id=6e3c7528&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c7528",
  null
  
)

export default component.exports